export const createProductIntegrationOptions = eventTypes => {
  let productCategoryAndNames = {};
  let productNamesAndEventType = {};

  eventTypes.forEach(eventType => {
    eventType.integratingProductNames.forEach(productName => {
      Object.keys(productNamesAndEventType).includes(productName)
        ? !productNamesAndEventType[productName].includes(
            eventType.eventTypeCategory
          ) &&
          productNamesAndEventType[productName].push(
            eventType.eventTypeCategory
          )
        : (productNamesAndEventType[productName] = [
            eventType.eventTypeCategory
          ]);

      Object.keys(productCategoryAndNames).includes(eventType.productCategory)
        ? !productCategoryAndNames[eventType.productCategory].includes(
            productName
          ) &&
          productCategoryAndNames[eventType.productCategory].push(productName)
        : (productCategoryAndNames[eventType.productCategory] = [productName]);
    });
  });
  return {
    productCategoryAndNames,
    productNamesAndEventType
  };
};
